/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { AuthRoles } from 'jotai/auth';
import { authService } from 'services/auth/AuthService';

const isIndyUser = () => {
  const userRoles = authService.getRolesAllRealms();
  const authorizedIndyRoles: string[] = [AuthRoles.ADMIN, AuthRoles.Indy];
  return userRoles && userRoles?.some((item) => authorizedIndyRoles.includes(item));
};

export default isIndyUser;
